import { useEffect, useState } from "react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import user1 from "../../src/assets/cards/User1.svg";
import user2 from "../../src/assets/cards/User2.svg";
import user3 from "../../src/assets/cards/User3.svg";
import UserDelete from "./UserDelete";
import EditUser from "./EditUser";
import PasswordResetM from "./PasswordResetM";
import userSettings from "../../src/assets/Schedule/useredit.svg";
import { faL } from "@fortawesome/free-solid-svg-icons";
import ConfigModal from "./ConfigModal";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { useNavigate } from "react-router-dom";
import EmployeePhotoModal from "../facialrecognization/views/employeephotomodal";
import api from "../api/api";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Backdrop, CircularProgress } from "@mui/material";
import { cameraIcon, deleteIcon, editIcon, eyeIcon, MessageIcon } from "./svg";
import StatusChangeModal from "./statusconformation";
const UsersTable = ({ users, sortOrder,sortColumn,
  setSortColumn,
  lastActiveSort,
  setLastActiveSort,changestatus,setSortOrder,fetchUsersData, imagesdata, onFileChange }) => {
  const [loading, setLoading] = useState(false);
  const practiseid = window.getPracticeId();
  const [userDelete, setUserDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [userEdit, setUserEdit] = useState(false);
  const [PasswordReset, setPasswordReset] = useState(false);
  const [providerConfigModal, setproviderConfigModal] = useState(false);
  const [providerConfig, setproviderConfig] = useState(null);
  const [resetData, setResetData] = useState(null);
  const [selectedimg, setSelectedimg] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [photoloading, setPhotoLoading] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
const [selectedStatusUser, setSelectedStatusUser] = useState(null);

  const navigate = useNavigate();
  const DeleteModalClose = () => {
    setUserDelete(false);
  };

  const CloseEditUser = () => {
    setUserEdit(false);
    setSelectedimg("");
  };

  const CloseResendModal = () => {
    setPasswordReset(false);
  };

  const handelDeleteUser = (userId) => {
    setSelectedRow(userId);
    setUserDelete(true); // Open the modal
  };

  const handelEditUser = (userId) => {
    setSelectedRow(userId);

    const matchedImage = imagesdata.find((img) => img.rowid === userId?.id);

    if (matchedImage) {
      setSelectedimg(matchedImage);
    }
    setUserEdit(true); // Open the modal
  };
  const handelResendModal = (userId) => {
    setSelectedRow(userId.id);
    setResetData(userId);
    setPasswordReset(true); // Open the modal
  };
  const handleProviderConfig = (item) => {
    console.log("Opening modal with config:", item);
    setproviderConfigModal(true);
    setproviderConfig(item);
  };
  const handlecloseConfig = () => {
    setproviderConfigModal(false);
  };
  useEffect(() => {
    const matchedImage = imagesdata.find(
      (img) => img.rowid === selectedRow?.id
    );

    if (matchedImage) {
      setSelectedimg(matchedImage);
    }
  }, [users]);
  const handleViewPhotos = async (id) => {
    try {
      setPhotoLoading(true);
      const response = await api.get(
        `/v1/${practiseid}/onboarding-employee/${id}`
      );
      if (response.status === 200) {
        setSelectedImages(response.data.employee_images || []);
        setOpenModal(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPhotoLoading(false);
    }
  };

  return (
    <div
      className="inline-flex w-full mr-10 ml-10 justify-center items-center rounded-[10px] bg-[#FAFAF9] "
      style={{
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)", // Uniform shadow on all sides
      }}
    >
      <div className="w-full ">
        <div className="overflow-x-auto rounded-[10px]">
          <table className="table-auto min-w-full bg-[#FAFAF9] text-center rounded-[10px]">
            <thead
              className="sticky top-0 bg-[#50869A]  text-[white] rounded-tr-[10px]"
              style={{
                borderTopRightRadius: "10px",
                borderTopLeftRadius: "10px",
              }}
            >
              <tr className="text-[14px]">
                <th className="py-3 px-4 border-b border-gray-200   font-semibold">
                  First Name
                </th>
                <th className="py-3 px-4 border-b border-gray-200  font-semibold">
                  Last Name
                </th>
                <th className="py-3 px-4 border-b border-gray-200 font-semibold">
                  User Id
                </th>
                <th
  onClick={() => {
    setSortColumn("last_active");
    setLastActiveSort(lastActiveSort === "asc" ? "desc" : "asc");
  }}
  className="py-2 px-4 border-b border-gray-200 font-semibold cursor-pointer select-none"
>
  Last Active
  <span className="ml-1 text-xs">
    { lastActiveSort === "asc"
        ? "▲"
        : "▼"
      }
  </span>
</th>

       <th
  onClick={() => {
    setSortColumn("status");
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  }}
  className="py-2 px-4 border-b border-gray-200 font-semibold cursor-pointer select-none"
>
  Status
  <span className="ml-1 text-xs">
    {
       sortOrder === "asc"
        ? "▲"
        : "▼"
     }
  </span>
</th>

                <th className="py-2 px-4 border-b border-gray-200 font-semibold">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan="6"
                    className="py-2 px-4 text-center text-gray-500"
                  >
                    Loading...
                  </td>
                </tr>
              ) : users.length === 0 ? (
                <tr>
                  <td
                    colSpan="6"
                    className="py-2 px-4 text-center text-gray-500"
                  >
                    No Data Available
                  </td>
                </tr>
              ) : (
                users.map((item, index) => (
                  <tr key={index} className="font-inter text-[14px]">
                    <td className="py-2 pl-4 border-b border-gray-200 break-words">
                      <div className="flex items-center gap-2">
                        {(() => {
                          const matchedImage = imagesdata.find(
                            (img) => img.rowid === item.id
                          );

                          if (matchedImage) {
                            return (
                              <img
                                src={`data:image/jpeg;base64,${matchedImage.image}`}
                                alt="User"
                                className="w-8 h-8 rounded-full object-cover"
                              />
                            );
                          }

                          return (
                            <div className="w-8 h-8 rounded-full bg-[#CBD5E1] text-white flex items-center justify-center font-medium text-sm uppercase">
                              {item.firstname?.[0]}
                              {item.lastname?.[0]}
                            </div>
                          );
                        })()}

                        <div className="flex items-center gap-2">
                          <span>{item.firstname}</span>
                          {item?.config?.enrolled_id && (
                            <span className="text-[10px] font-semibold bg-[#DCFCE7] text-[#15803D] px-2 py-[2px] rounded-full">
                              Enrolled
                            </span>
                          )}
                        </div>
                      </div>
                    </td>

                    <td className="py-2 px-4 border-b border-gray-200 break-words">
                      {item.lastname}
                    </td>
                    <td className="py-2 px-4 border-b border-gray-200 break-words">
                      {item.username}
                    </td>
                    <td className="py-2 px-4 border-b border-gray-200 break-words">
                      {item.last_login && item.last_login.replace("T", " ")}
                    </td>

                    <td className="py-2 px-4 border-b border-gray-200">
                      <button
                        onClick={() => {
    if (item.locked_status === "I") return; // 🔒 Locked → Do nothing

    setSelectedStatusUser(item);
    setStatusModalOpen(true);
  }}
                        className={`rounded-full py-1 px-3 w-[auto] text-[12px] 
    ${
      item.status === "I"
        ? "bg-[#FFEDD5] text-[#C2410C]" // Inactive (you can keep your existing color if needed)
        : item.locked_status === "I"
        ? "bg-[#9CA3AF] text-white" // Locked
        : item.status === "A"
        ? "bg-[#FFEDD5] text-[#C2410C]" // Active
        : ""
    } 
    shadow-md max-w-[120px] whitespace-nowrap`}
                      >
                        {item.status === "I"
                          ? "Inactive"
                          : item.locked_status === "I"
                          ? "Locked"
                          : item.status === "A"
                          ? "Active"
                          : ""}
                      </button>
                    </td>
                    <td className="py-2 px-4 border-b border-gray-200">
                      <div className="flex gap-2 items-center">
                        <div
                          onClick={() => handelResendModal(item)}
                          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-[#1D2951] text-[#71717A] hover:text-[#FFF] cursor-pointer"
                        >
                          {/* <img src={user3} alt="$1"  /> */}
                          {MessageIcon}
                        </div>

                        <div
                          onClick={() => handelEditUser(item)}
                          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-[#1D2951] text-[#71717A] hover:text-[#FFF] cursor-pointer"
                        >
                          {/* <img src={user2} alt="$1" /> */}
                          {editIcon}
                        </div>

                        <div
                          onClick={() => handelDeleteUser(item)}
                          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-[#1D2951] text-[#71717A] hover:text-[#FFF] cursor-pointer"
                        >
                          {/* <img src={user1} alt="$1"  /> */}
                          {deleteIcon}
                        </div>
                        {item?.config?.enrolled_id ? (
                          <div
                            className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-[#1D2951] text-[#71717A] hover:text-[#FFF] cursor-pointer"
                            onClick={() =>
                              handleViewPhotos(item?.config?.enrolled_id)
                            }
                          >
                            {eyeIcon}
                          </div>
                        ) : (
                          <div
                            className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-[#1D2951] text-[#71717A] hover:text-[#FFF] cursor-pointer"
                            onClick={() =>
                              navigate(
                                `/onboard-emp?userid=${item.id}&username=${item.username}&email=${item.email}&phone=${item.phone}`
                              )
                            }
                          >
                            {cameraIcon}
                          </div>
                        )}

                        {item.providerid ? (
                          <div
                            onClick={() => handleProviderConfig(item)}
                            className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-[#FFEDD5] cursor-pointer"
                          >
                            <img src={userSettings} alt="$1" />
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <EmployeePhotoModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        images={selectedImages}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.7)", // reduced opacity (default is 0.5)
        }}
        open={photoloading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {userDelete && (
        <UserDelete
          fetchUsersData={fetchUsersData}
          DeleteModalClose={DeleteModalClose}
          userrowId={selectedRow}
        />
      )}
      {userEdit && (
        <EditUser
          onFileChange={onFileChange}
          img={selectedimg.image}
          fetchUsersData={fetchUsersData}
          CloseEditUser={CloseEditUser}
          userrow={selectedRow}
        />
      )}
      {PasswordReset && (
        <PasswordResetM
          CloseResendModal={CloseResendModal}
          userData={resetData}
        />
      )}
      {statusModalOpen && (
  <StatusChangeModal
    user={selectedStatusUser}
    onClose={() => setStatusModalOpen(false)}
    onConfirm={(user)=>{
changestatus(user)
setStatusModalOpen(false)
    }}
  />
)}

      {providerConfigModal && (
        <ConfigModal
          handlecloseConfig={handlecloseConfig}
          providerConfig={providerConfig}
        />
      )}
    </div>
  );
};

export default UsersTable;
